import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { DeleteResultType } from '../../types/utils/delete-result.type';
import { setShowModal, setModalContent } from '../utils/utils.slice';
import { rejectWithApiError } from '../../utils/api';
import { RootReducerState } from '../../redux/Reducers';
import { getDIDE911 } from '../dids/dids.action';

export const deleteAddressDetails = createAsyncThunk<
  DeleteResultType,
  { id: number; isE911Address?: boolean },
  { state: RootReducerState }
>('addresses/deleteAddressDetails', async ({ id, isE911Address }, thunkAPI) => {
  try {
    const response = await axios.delete<DeleteResultType>(`${process.env.REACT_APP_API_URL}/addresses/${id}`);

    thunkAPI.dispatch(setShowModal(false));
    thunkAPI.dispatch(setModalContent(null));

    if (isE911Address) {
      const { didDetails } = thunkAPI.getState().didsReducer;
      if (didDetails) thunkAPI.dispatch(getDIDE911({ id: didDetails.id }));
    }

    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error during deleting address!' });
  }
});
